import React, { Component } from 'react';
import HttpService from '../../util/HttpService';
import { If } from '../../components/ConditionalRendering';
import { isDefined, decimalFormat, tipoFreteOptions, b64toBlob } from '../../util/Common';
import * as LocalStorageManager from '../../util/StorageManager';
import { Icon, Divider, Table, TextArea, Button, Label, Form, Dimmer, Loader, Modal } from 'semantic-ui-react';
import download from "downloadjs";
import Moment from 'moment';
import _ from 'lodash';

class DetalhePedido extends Component {

    constructor(){
        super();
        this.state = {
            pedido: {},
            isPrinting: false,
            isLoading: false
        }
    }

    componentDidMount(){
        /* Busca o parametro :idtPedido na URL, declarado no Router */
        if(isDefined(this.props.match) && isDefined(this.props.history)){
            this.buscarDetalhesPedido(this.props.match.params.idtPedido);
        }
    }
    
    buscarDetalhesPedido = (idtPedido) => {
        this.setState({ isLoading: true });
        idtPedido = parseInt(idtPedido, 10);
        const urlPedidos = this.props.match.url.replace('/' + idtPedido, '');
        
        if(isNaN(idtPedido)){
            this.props.history.push(urlPedidos);
        }else{
            HttpService.call(
                'cadastro/orcamentoVenda',
                'buscarDetalhesPedido',
                [
                    idtPedido,
                    LocalStorageManager.getOrigem().idt,
                    'N', // isOrcamento = 'N', são os pedidos fechados
                ],
                (pedido) => {
                    if(isDefined(pedido)){
                        pedido.dataEntrega = isDefined(pedido.dataEntrega) ? new Moment(pedido.dataEntrega, 'YYYYMMDD') : null;
                        pedido.dataPedido = new Moment(pedido.dataPedido, 'YYYYMMDD');
                        
                        this.setState({ pedido, isLoading: false });
                    }else{
                        this.props.history.push(urlPedidos);
                    }
                }
            )
        }
    }

    imprimirPedido = () => {
        this.setState({ isPrinting: true });
        
        HttpService.call(
			'consulta/documento',
			'imprimirPedido',
			[
                this.state.pedido.idtPedido,
                LocalStorageManager.getOrigem().idt,
                'PORTAL PEDIDOS'
            ],
			(documento) => {
                this.setState({ isPrinting: false })
                
				if(isDefined(documento)){
                    download(b64toBlob(documento.data, documento.mimeType), documento.filename, documento.mimeType);
				}
			}
        )
    }

    fecharModal = () => {
        const idtPedido = parseInt(this.props.match.params.idtPedido, 10);
        const urlPedidos = this.props.match.url.replace('/' + idtPedido, '');
        
        this.props.history.push(urlPedidos);
    }

    render(){
        const { pedido, isLoading, isPrinting } = this.state;
        const isCliente = LocalStorageManager.getLoggedUser().isCliente;
        const tipoFrete = _.find(tipoFreteOptions, t => t.value === pedido.tipoFrete);

        return (
            <Modal open size='large'>
                <Modal.Header>
                { 
                    isDefined(pedido.idtPedido) ? (
                        <span>
                            Pedido <a>#{ pedido.idtPedido }</a>
                        </span>
                    ) : ( 
                        'Carregando pedido...' 
                    )
                }
                </Modal.Header>
                <Modal.Content scrolling>
                {
                    isLoading && !isDefined(pedido.idtPedido) ? (
                        <Dimmer active inverted>
                            <Loader>Carregando</Loader>
                        </Dimmer>
                    ) : (
                        <Modal.Description>
                            <Form size='small'>
                                <Form.Group>
                                    <Form.Field width={4}>
                                        <label>Data</label>
                                        <Label size='large' className='fluid'>{isDefined(pedido.dataPedido) ? pedido.dataPedido.format('DD/MM/YYYY') : ''}</Label>
                                    </Form.Field>
                                    <Form.Field width={4}>
                                        <label>Controle</label>
                                        <Label size='large' className='fluid'>{pedido.controle}</Label>
                                    </Form.Field>
                                    <If test={isCliente}>
                                        <Form.Field width={8}>
                                            <label>Vendedor</label>
                                            <Label size='large' className='fluid'>{pedido.nomeVendedor}</Label>
                                        </Form.Field>
                                    </If>
                                    <If test={!isCliente}>
                                        <Form.Field width={8}>
                                            <label>Supervisor</label>
                                            <Label size='large' className='fluid'>{pedido.nomeSupervisor}</Label>
                                        </Form.Field>
                                    </If>
                                </Form.Group>
                                <If test={!isCliente}>
                                    <Form.Field>
                                        <label>Cliente</label>
                                        <Label size='large' className='fluid'>{pedido.nomeCliente}</Label>
                                    </Form.Field>
                                </If>
                                <Form.Group widths='equal'>
                                    <Form.Field width={4}>
                                        <label>Quantidade de produtos</label>
                                        <Label size='large' className='fluid'>{pedido.quantidadeItens}</Label>
                                    </Form.Field>
                                    <Form.Field width={4}>
                                        <label>Valor Total (R$)</label>
                                        <Label size='large' className='fluid text-align-right'>{decimalFormat(pedido.valorTotal, 2)}</Label>
                                    </Form.Field>
                                    <Form.Field width={8}>
                                        <label>Forma de pagamento</label>
                                        <Label size='large' className='fluid'>{pedido.nomeFormaPagamento}</Label>
                                    </Form.Field>
                                </Form.Group>
                                <Form.Field control={TextArea} readOnly label='Observações' value={pedido.observacoes} />
                            </Form>
                            <Divider horizontal>Frete</Divider>
                            <Form size='small'>
                                <Form.Group widths='equal'>
                                    <Form.Field>
                                        <label>Tipo de frete</label>
                                        <Label size='large' className='fluid'>{isDefined(tipoFrete) ? tipoFrete.text : ''}</Label>
                                    </Form.Field>
                                    <Form.Field>
                                        <label>CEP</label>
                                        <Label size='large' className='fluid'>{pedido.cep}</Label>
                                    </Form.Field>
                                    <Form.Field>
                                        <label>Valor (R$)</label>
                                        <Label size='large' className='fluid'>{decimalFormat(pedido.valorFrete, 2)}</Label>
                                    </Form.Field>
                                    <Form.Field>
                                        <label>Data de entrega</label>
                                        <Label size='large' className='fluid'>{isDefined(pedido.dataEntrega) ? pedido.dataEntrega.format('DD/MM/YYYY') : ''}</Label>
                                    </Form.Field>
                                </Form.Group>
                                <Form.Group>
                                    <Form.Field width={8}>
                                        <label>Endereço</label>
                                        <Label size='large' className='fluid'>{pedido.endereco}</Label>
                                    </Form.Field>
                                    <Form.Field width={2}>
                                        <label>Número</label>
                                        <Label size='large' className='fluid'>{pedido.numeroEndereco}</Label>
                                    </Form.Field>
                                    <Form.Field width={6}>
                                        <label>Complemento</label>
                                        <Label size='large' className='fluid'>{pedido.complemento}</Label>
                                    </Form.Field>
                                </Form.Group>
                                <Form.Group widths='equal'>
                                    <Form.Field>
                                        <label>Bairro</label>
                                        <Label size='large' className='fluid'>{pedido.bairro}</Label>
                                    </Form.Field>
                                    <Form.Field>
                                        <label>Cidade</label>
                                        <Label size='large' className='fluid'>{pedido.cidade}</Label>
                                    </Form.Field>
                                    <Form.Field>
                                        <label>Estado</label>
                                        <Label size='large' className='fluid'>{pedido.estado}</Label>
                                    </Form.Field>
                                </Form.Group>
                            </Form>
                            <Divider horizontal>Produtos</Divider>
                            <Table compact striped selectable singleLine size='small'>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell textAlign='center'>Código</Table.HeaderCell>
                                        <Table.HeaderCell textAlign='left'>Descrição</Table.HeaderCell>
                                        <Table.HeaderCell textAlign='center'>Quantidade</Table.HeaderCell>
                                        <Table.HeaderCell textAlign='center'>Valor unitário (R$)</Table.HeaderCell>
                                        <Table.HeaderCell textAlign='center'>Desconto (%)</Table.HeaderCell>
                                        <Table.HeaderCell textAlign='center'>Valor total (R$)</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                {   
                                    isDefined(pedido.produtos) && pedido.produtos.length > 0 ? (
                                        pedido.produtos.map((item, index) => {
                                            return <Table.Row key={index}>
                                                        <Table.Cell textAlign='center'>{item.codigo}</Table.Cell>
                                                        <Table.Cell textAlign='left'>{item.descricao}</Table.Cell>
                                                        <Table.Cell textAlign='right'>{decimalFormat(item.quantidade, 3)}</Table.Cell>
                                                        <Table.Cell textAlign='right'>{decimalFormat(item.valorUnitario, 2)}</Table.Cell>
                                                        <Table.Cell textAlign='right'>{decimalFormat(item.percentualDesconto, 2)}</Table.Cell>
                                                        <Table.Cell textAlign='right'>{decimalFormat(item.valorTotal, 2)}</Table.Cell>
                                                    </Table.Row>
                                        })
                                    ) : (
                                        <Table.Row>
                                            <Table.Cell colSpan='5'>Nenhum produto adicionado.</Table.Cell>
                                        </Table.Row>
                                    )
                                }
                                </Table.Body>
                            </Table>
                        </Modal.Description>
                    )
                }
                </Modal.Content>
                <Modal.Actions>
                    <Button negative floated='left' content='Fechar' icon='window close' onClick={this.fecharModal} />
                    <Button secondary loading={isPrinting} onClick={this.imprimirPedido}>
                        <Icon name='print'/>
                        Imprimir
                    </Button>
                </Modal.Actions>
            </Modal>
        )
    }
}

export default DetalhePedido;


// WEBPACK FOOTER //
// ./src/views/PedidoVenda/DetalhePedido.js